import { sva } from "styled-system/css";

export const timelineGroupItemRecipe = sva({
  slots: ["root", "circle", "tag", "title", "description", "action"],
  base: {
    root: {
      flexDir: "column",
      gap: "100",
      borderRadius: "150",
      px: "300",
      py: "250",
      w: "full",
    },
    circle: {
      w: "8px",
      h: "8px",
      borderRadius: "full",
    },
    tag: {},
    title: {},
    description: {},
    action: {},
  },
  variants: {
    visual: {
      activity: {
        root: {
          bgColor: "bg.accent.blue.lightest",
        },
        circle: {
          bgColor: "bg.accent.blue.mid",
        },
        tag: {
          color: "text.accent.blue.mid",
        },
        action: {
          color: "text.accent.blue.mid",
          _hover: {
            color: "text.accent.blue.dark",
          },
          _focusVisible: {
            color: "text.accent.blue.dark",
          },
        },
      },
      purchase: {
        root: {
          bgColor: "bg.success.lightest",
        },
        circle: {
          bgColor: "bg.success.mid",
        },
        tag: {
          color: "text.success.mid",
        },
        action: {
          color: "text.success.mid",
          _hover: {
            color: "text.success.dark",
          },
          _focusVisible: {
            color: "text.success.dark",
          },
        },
      },
      inquiry: {
        root: {
          bgColor: "bg.accent.magenta.lightest",
        },
        circle: {
          bgColor: "bg.accent.magenta.mid",
        },
        tag: {
          color: "text.accent.magenta.mid",
        },
        action: {
          color: "text.accent.magenta.mid",
          _hover: {
            color: "text.accent.magenta.dark",
          },
          _focusVisible: {
            color: "text.accent.magenta.dark",
          },
        },
      },
      broadcast: {
        root: {
          bgColor: "bg.accent.purple.lightest",
        },
        circle: {
          bgColor: "bg.accent.purple.mid",
        },
        tag: {
          color: "text.accent.purple.mid",
        },
        action: {
          color: "text.accent.purple.mid",
          _hover: {
            color: "text.accent.purple.dark",
          },
          _focusVisible: {
            color: "text.accent.purple.dark",
          },
        },
      }
    },
  },
  defaultVariants: {
    visual: "activity",
  },
});
